import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../authentication';
import { useOrganizations } from '../providers/OrganizationsProvider';

const useOrganization = (navigate) => {
  const { user } = useAuth();
  const { createOrganization } = useOrganizations();

  const queryClient = useQueryClient();

  const handleCreateOrganization = (close) => {
    if (close) {
      close();
    } else {
      navigate('/');
    }
    queryClient.invalidateQueries(['membership', 'organizations']);
  };

  const onSubmit = (close) => async (data) => {
    await createOrganization(data);
    handleCreateOrganization(close);
  };

  const onSkip = async () => {
    await createOrganization({ name: user.email, displayName: user.name });
    handleCreateOrganization();
  };

  return { onSubmit, onSkip, handleCreateOrganization };
};

export { useOrganization };
